import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import theme from "Theme/AppTheme";

type Props = {
    authenticatorUri: string;
    manualEntryKey: string;
};

export default function MfaSetupInstructions({
    authenticatorUri,
    manualEntryKey,
}: Props) {
    const [qrCodeDataUri, setQrCodeDataUri] = useState("");

    useEffect(() => {
        let isMounted = true;

        void (async () => {
            if (!authenticatorUri) {
                setQrCodeDataUri("");
                return;
            }

            const nextQrCodeDataUri = await QRCode.toDataURL(authenticatorUri, {
                margin: 2,
                width: 200,
            });

            if (isMounted) {
                setQrCodeDataUri(nextQrCodeDataUri);
            }
        })();

        return () => {
            isMounted = false;
        };
    }, [authenticatorUri]);

    return (
        <Stack sx={{ gap: 2, width: "100%" }}>
            <Box
                sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    padding: 1.5,
                    backgroundColor: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    px: {
                        xs: 2,
                        sm: 6.25,
                    },
                    py: 2.5,
                }}
            >
                {qrCodeDataUri ? (
                    <img
                        src={qrCodeDataUri}
                        alt="Authenticator QR code"
                        width={200}
                        height={200}
                    />
                ) : (
                    <Typography variant="body2">
                        Generating QR code...
                    </Typography>
                )}
            </Box>
            <Box
                sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    padding: 1,
                    backgroundColor: theme.palette.gray[100],
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "monospace",
                        fontSize: "14px",
                        lineHeight: "20px",
                        letterSpacing: "0.08em",
                        wordBreak: "break-word",
                        color: theme.palette.gray[600],
                    }}
                >
                    {manualEntryKey}
                </Typography>
            </Box>
        </Stack>
    );
}
